import {
  getAmotConstructionLobbyV2,
  getAmotConstructionSimilarAssetsSlug,
  getAmotConstructionSlug,
} from "api"
import { getSiteIdByLocale } from "api/SiteId"
import { reducePageDataToCardData } from "common/dataReducers/reducePageDataToCardData"
import AssetSlug from "components/asset/AssetSlug"

export const getStaticPaths = async ({ locales }) => {
  const paths = []

  const allPromises = locales.map(async (locale) => {
    const siteId = getSiteIdByLocale(locale)
    const projectPaths = await getAmotConstructionLobbyV2(siteId)
    const lastOfSlug = (path) => path?.split("/").pop()
    projectPaths?.data.forEach((project) => {
      paths.push({
        params: {
          projectSlug: lastOfSlug(project),
        },
      })
    })
  })

  // Wait for all the promises to resolve
  await Promise.all(allPromises)
  return {
    paths,
    fallback: "blocking",
  }
}

export const getStaticProps = async ({ locale, params }) => {
  const { projectSlug } = params
  const slugPath = `construction/${projectSlug}`

  const siteId = getSiteIdByLocale(locale)
  const response = await getAmotConstructionSlug(slugPath, siteId)
  let similarAssets

  try {
    const reply = await getAmotConstructionSimilarAssetsSlug(slugPath, siteId)
    similarAssets = reply?.data || []
  } catch (error) {
    similarAssets = []
  }

  const data = {
    ...response?.data,
    pages: [],
  }

  const messagesResponse = await import(`../../../messages/${locale}.json`)
  const messages = messagesResponse.default
  if (!data) {
    return { notFound: true }
  }
  return {
    props: {
      messages,
      data,
      similarAssets: similarAssets?.map(reducePageDataToCardData),
    },
    revalidate: 60,
  }
}

const ProjectSlug = ({ data, similarAssets }) => {
  const type = "construction"
  return <AssetSlug data={data} type={type} similarAssets={similarAssets} />
}

export default ProjectSlug
